import { useState, useContext, FC } from 'react'
import { useRouter } from 'next/router'
import { useMounted } from 'hooks'
import { useTheme } from 'next-themes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Box, Button, Flex, Text } from 'components/primitives'
import {
  DropdownMenuItem,
  DropdownMenuContent,
} from 'components/primitives/Dropdown'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'

import { BlockchainData } from './../../constants/DragonsHolder'
import { useChain } from '@thirdweb-dev/react'
import { ChainContext } from 'context/ChainContextProvider'

type ChainDropDownProps = {
  blockchainData: BlockchainData[]
  onSelect: (data: BlockchainData) => void
  selectedChain: BlockchainData | null
  primary?: boolean
}

export const ChainDropDown: FC<ChainDropDownProps> = ({
  blockchainData,
  onSelect,
  selectedChain,
  primary,
}) => {
  const router = useRouter()
  const isMounted = useMounted()
  const { theme } = useTheme()
  //const _chain = useChain();
  const { chain, switchCurrentChain } = useContext(ChainContext)

  if (primary) {
    selectedChain = getChain()
    onSelect(selectedChain)
  }
  function updateChain(chain: BlockchainData) {
    if (primary) {
      switchCurrentChain(chain.chainId)
    }
    onSelect(chain)
  }
  function getChain(): BlockchainData {
    const chainData = blockchainData.find(
      (data) => data.chain === chain.routePrefix.toLocaleLowerCase()
    )
    console.log('getChain')
    console.log(chainData)
    return chainData!
  }

  const isDarkMode = theme === 'dark'

  if (!isMounted || blockchainData.length === 0) {
    return null
  }
  function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button className="px-3 justify-between md:w-220 md:min-w-max md:px-4 text-black dark:text-white bg-primary h-[44px]">
          <Flex className="flex-row items-center">
            {selectedChain && (
              <Image
                src={
                  isDarkMode
                    ? selectedChain.darkIconUrl
                    : selectedChain.lightIconUrl
                }
                width={20}
                height={20}
                alt={selectedChain.chain}
              />
            )}
            <Text style="body1" className="ml-2 text-black dark:text-white">
              {selectedChain
                ? capitalizeFirstLetter(selectedChain.chain)
                : 'Select Chain'}
            </Text>
          </Flex>
          <Box className="text-gray-500 transition-transform [data-state=open] &">
            <FontAwesomeIcon icon={faChevronDown} width={16} />
          </Box>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenuContent className="w-[450px] mt-2 z-10 bg-white dark:bg-jacarta-600 text-black dark:text-white border-jacarta-900 ">
        {blockchainData.map((chainOption) => (
          <DropdownMenuItem
            key={chainOption.collectionAddress}
            className="w-220 py-3 hover:bg-accent-light dark:hover:bg-accent-light"
            onClick={() => updateChain(chainOption)}
          >
            <Flex className="flex-row items-center">
              <Image
                src={
                  isDarkMode
                    ? chainOption.darkIconUrl
                    : chainOption.lightIconUrl
                }
                width={20}
                height={20}
                alt={chainOption?.chain}
              />
              <Text style="body1" className="ml-2 text-black dark:text-white">
                {capitalizeFirstLetter(chainOption.chain)}
              </Text>
            </Flex>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu.Root>
  )
}
